import styled from '@emotion/styled';

import { Button, type FlexProps, Flex } from 'antd';

export const Inner = styled(Flex)<FlexProps>`
  padding: 32px 0;
`;

export const Navigation = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const NavButton = styled(Button)`
  display: inline-flex;
  align-items: center;
  gap: 6px;
`;
